var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSummeringEjObligatorisk25Px25Px = function SvgSummeringEjObligatorisk25Px25Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#A2AAAD"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M12.5 18.5v1h1v-1zm0-13v10h1v-10z"
  }))));
};
export default SvgSummeringEjObligatorisk25Px25Px;